import { render, staticRenderFns } from "./LiquidationTypeSelect.vue?vue&type=template&id=1d6d59ca&scoped=true&"
import script from "./LiquidationTypeSelect.vue?vue&type=script&lang=js&"
export * from "./LiquidationTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d59ca",
  null
  
)

export default component.exports